import { WB_W, WB_H, uid } from './whiteboardShapes';

const API = process.env.REACT_APP_BACKEND_URL;
const TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/gif'];
const MAX_BYTES = 10 * 1024 * 1024;

const naturalSize = (url) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => resolve({ w: img.naturalWidth || 400, h: img.naturalHeight || 300 });
  img.onerror = () => resolve({ w: 400, h: 300 });
  img.src = url;
});

// Upload to the existing media store (GridFS) and return a centred image layer. PNG transparency is kept as-is.
export async function uploadImageLayer(file) {
  if (!TYPES.includes(file.type)) throw new Error('Please choose a PNG, JPG, WebP or GIF image.');
  if (file.size > MAX_BYTES) throw new Error('Image must be under 10MB.');
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(`${API}/api/media/upload`, {
    method: 'POST', headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, body: form,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Image upload failed.');
  const nat = await naturalSize(data.url);
  const k = Math.min(1, 460 / nat.w, 320 / nat.h);
  const w = Math.round(nat.w * k), h = Math.round(nat.h * k);
  return { id: uid(), type: 'image', src: data.url, x: (WB_W - w) / 2, y: (WB_H - h) / 2, w, h, opacity: 1, name: file.name.slice(0, 60) };
}
